import React, { useState, useEffect, useMemo, useRef } from "react";
import { FormGroup, Alert, Row, Col, Button } from "reactstrap";
import { FormFieldRadio, IconItem, StatusText } from "pickups-ui-library";
import * as Icons from "pickups-ui-library/styles/icons";
import { Field } from "redux-form";
import FormNavigation from "../navigation.component";

const RequiredSymbol = () => (
  <>
    {" "}
    <span
      style={{
        color: "red",
      }}
    >
      *
    </span>
  </>
);

const Adjustments = ({ currentPickupType, setIsDisabled }) => {
  const { adjustments, id } = currentPickupType;
  const adjustmentsExist = useMemo(
    () => adjustments && Object.keys(adjustments).length !== 0,
    [adjustments]
  );
  const [isAcceptAll, setIsAcceptAll] = useState(false);
  const [adjustmentRequired, setAdjustmentRequired] = useState({});

  useEffect(() => {
    if (adjustmentsExist) {
      const keys = {};
      Object.keys(adjustments).map((key) => {
        if (adjustments[key].required) {
          keys[key] = false;
        }
      });
      setAdjustmentRequired(keys);
    }
  }, [adjustments]);

  useEffect(() => {
    if (Object.keys(adjustmentRequired).length !== 0) {
      setIsDisabled(!isAcceptAll);
    } else {
      setIsDisabled(false);
    }
  }, [isAcceptAll, adjustmentRequired]);

  const onCheckbox = (required, key) => (e) => {
    if (required) {
      setAdjustmentRequired((prev) => {
        prev[key] = e.target.checked;
        let isAcceptedAll = true;
        for (let key in prev) {
          if (!prev[key]) {
            isAcceptedAll = false;
          }
        }
        setIsAcceptAll(isAcceptedAll);
        return prev;
      });
    }
  };

  return (
    <>
      {Object.keys(adjustmentRequired).length !== 0 && (
        <div style={{ marginTop: "2em" }}>Please read and accept each:</div>
      )}
      {adjustmentsExist ? (
        <div
          className={"box"}
          style={{ padding: ".5em 1em", margin: "1rem 0" }}
        >
          {" "}
          {Object.keys(adjustments).map((key) => {
            const { text, required } = adjustments[key];
            return (
              <div
                key={`${id}${key}`}
                // color={
                //   required
                //     ? adjustmentRequired[key]
                //       ? "success"
                //       : "warning"
                //     : "info"
                // }
              >
                <div className="radio-wrap" style={{ paddingBottom: ".5em" }}>
                  <input
                    id={`${id}${key}`}
                    type="checkbox"
                    onChange={onCheckbox(required, key)}
                  />{" "}
                  <label for={`${id}${key}`} className="radio-button">
                    <span dangerouslySetInnerHTML={{ __html: text }} />
                    {required && <RequiredSymbol />}
                  </label>
                </div>
              </div>
            );
          })}{" "}
        </div>
      ) : null}
    </>
  );
};

const PickupBlockResponse = (props) => {
  const {
    pickupTypes,
    pickupTypesAvailable,
    onlyOnePickupType,
    pickupTypesId,
    noPickupBlocksAlert,
    onClickAutoComplete,
    setIsExistRequired,
    onSelect,
  } = props;
  const currentPickupType = pickupTypesAvailable.find(
    (type) => type.id === pickupTypesId
  );

  return (
    <div>
      {/*<Alert color="success">Great, we have upcoming pickup dates for bags, boxes, and large items, including furniture in your area.</Alert>*/}
      <div className={"box p-3 mb-2"}>
        {currentPickupType?.donorMessage && (
          <Alert color="info">
            <strong style={{ marginRight: 10 }} />
            <span>{currentPickupType.donorMessage}</span>
          </Alert>
        )}
        {pickupTypesAvailable.map((item) => {
          const active = item.id === pickupTypesId;

          return (
            <div
              className={"box"}
              key={item.id}
              onClick={() => {
                onSelect(item.id);
              }}
            >
              <IconItem
                Icon={Icons[item.icon] ? Icons[item.icon] : Icons.OnRoute}
                className={active ? `active` : `disabled`}
              >
                <StatusText title={item.title} subTitle={item.subtitle} />
              </IconItem>
            </div>
          );
        })}
        {currentPickupType && (
          <Adjustments
            setIsDisabled={props.setIsDisabled}
            currentPickupType={currentPickupType}
            setIsExistRequired={setIsExistRequired}
          />
        )}
      </div>

      {/*<RenderOnlyOnePickupTypeMessage pickupType={onlyOnePickupType} />*/}

      {noPickupBlocksAlert ? (
        <Alert color="warning">
          Unfortunately we have not started to service your area yet.
          <div className="pull-right">
            <Button
              onClick={() => {
                onClickAutoComplete();
              }}
            >
              Try Again
            </Button>
          </div>
        </Alert>
      ) : null}
    </div>
  );
};

const RenderOnlyOnePickupTypeMessage = ({ pickupType }) => {
  if (!pickupType) {
    return <></>;
  }
  return (
    <>
      <Alert color="warning">
        At this time we can only pick up '{pickupType.label}' type.
      </Alert>
    </>
  );
};

const ChooseLocation = (props) => {
  const { handleSubmit, error } = props;
  const [isDisabled, setIsDisabled] = useState(true);
  let errorMessage,
    noPickupBlocksAlert = false;

  if (error) {
    if (error === "empty") {
      noPickupBlocksAlert = true;
    } else {
      if (error.message) {
        errorMessage = error.message;
      }
    }
  }

  return (
    <form
      onSubmit={(e) => {
        const selectedPickupTypeId = props.pickupTypesId;
        const selectedPickupType = props.pickupTypesAvailable.find(
          (type) => type.id === selectedPickupTypeId
        );
        props.setFormData({
          requireAcceptDonationGuidelines:
            selectedPickupType.requireAcceptDonationGuidelines,
        });
        handleSubmit(e);
      }}
    >
      <FormGroup>
        <Row>
          <Col xs={12}>
            <div>
              <PickupBlockResponse
                {...props}
                setIsDisabled={setIsDisabled}
                noPickupBlocksAlert={noPickupBlocksAlert}
              />
              <FormNavigation {...props} isDisabled={isDisabled} />
            </div>
          </Col>
        </Row>
        {errorMessage ? <Alert color="danger">{errorMessage}</Alert> : null}
      </FormGroup>
    </form>
  );
};

export default ChooseLocation;
